// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"b9cb41c5","51":"92072ac6","134":"58e1cbd1","488":"fecd9582","932":"99cd4cb4"}[chunkId] + ".chunk.js";
};